module.exports = {"id":"140620","name":"Ragnar Klavan","rating":"78","photo":"./data/images/photos/3/140620.png","club":{"name":"Liverpool","logo":"./data/images/clubs/Liverpool.png"},"positions":["DC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/RagnarKlavan0.json
// module id = 3521
// module chunks = 0